export const SCHEDULER_CX_HELP_HOTLINE = '+18776613166';
/**
 * If the user wants to switch off their device timezone, these are the options we offer.
 */
export enum DEFAULT_SUPPORTED_TIMEZONES {
    EASTERN_TIME = 'America/New_York',
    CENTRAL_TIME = 'America/Chicago',
    MOUNTAIN_TIME = 'America/Phoenix',
    PACIFIC_TIME = 'America/Los_Angeles',
    HAWAII_TIME = 'Pacific/Honolulu',
    ALASKA_TIME = 'America/Anchorage',
    DEVICE_TIME = 'Device timezone',
}

export const SUPPORTED_TIMEZONE_TO_LEGIBLE_NAME: Record<DEFAULT_SUPPORTED_TIMEZONES, string> = {
    [DEFAULT_SUPPORTED_TIMEZONES.ALASKA_TIME]: 'Alaska time',
    [DEFAULT_SUPPORTED_TIMEZONES.CENTRAL_TIME]: 'Central time',
    [DEFAULT_SUPPORTED_TIMEZONES.PACIFIC_TIME]: 'Pacific time',
    [DEFAULT_SUPPORTED_TIMEZONES.EASTERN_TIME]: 'Eastern time',
    [DEFAULT_SUPPORTED_TIMEZONES.MOUNTAIN_TIME]: 'Mountain time',
    [DEFAULT_SUPPORTED_TIMEZONES.HAWAII_TIME]: 'Hawaii time',
    [DEFAULT_SUPPORTED_TIMEZONES.DEVICE_TIME]: 'Device timezone',
};

export enum CALLBACK_SCHEDULER_SCREENS {
    SCHEDULER = 'scheduler',
    CONFIRMATION = 'confirmation',
    FAILURE = 'failure',
}
